import { drupalSettingsData } from '@/helpers';
import type { Facet, FacetGroup, Garage } from '@/types';

function createQuery(params: any) {
	return Object.keys(params)
	  .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
	  .join('&')
 }

export async function loadData(url: string, params: any) {
	let fullUrl = url;

	if( Object.keys(params).length ) {
		fullUrl += '?' + createQuery(params);
	}

	return await fetch( fullUrl )
		.then( ( data ) => data.json() )
		.then( ( json ) => {
			return json;
		} );
}


const convertZeroOneToBoolean = function(value: string|number|boolean ) {
	switch( value) {
		case '1':
		//case 1:
			return true;
		case '0':
		//case 0:
			return false;
		default:
			return false;
	}
}

//with the current data, this is the quickest solution
const decodeHtmlEntities = function(value: string)  {
	return value.replace('&amp;', '&');
}

export function convertGarages(data: any): Readonly<Garage>[] {
	const garages: Garage[] = [];

	if( ! data.search_results ) {
		console.info("Empty search_result");
		return garages;
	}

	for(let garageObject of data.search_results) {
		if( ! garageObject.geolocation ) {
			console.error('Missing field geolocation');
			continue;
		}

		const [lat, lng]: string[] = garageObject.geolocation.split(',')
		const garage: Garage = {
			id: parseInt( garageObject.nid, 10 ),
			url: garageObject.link,
			name: decodeHtmlEntities(garageObject.title),
			postal: garageObject.address_postcode,
			city: garageObject.address_city,
			street: garageObject.address_street,
			country: (garageObject.country as string)?.toLowerCase(),
			lat: parseFloat( lat.trim() ),
			lng: parseFloat( lng.trim() ),
			position: { lat: parseFloat( lat.trim() ), lng: parseFloat( lng.trim() ) },
			charging_available: convertZeroOneToBoolean(garageObject.charging_available),
			sharing_available: convertZeroOneToBoolean(garageObject.sharing_available),
			parking_available: true,
			charging_hubs: parseInt( garageObject.charging_hubs, 10 ),
			parking_car_spaces: parseInt( garageObject.parking_car_spaces, 10 ),
			image: garageObject.image?.media_image,
			external_url: garageObject.external_link,
			driveway_height: parseFloat(garageObject.driveway_height) ? parseFloat(garageObject.driveway_height).toLocaleString(drupalSettingsData().current_language ?? 'de', { minimumFractionDigits: 2, maximumFractionDigits: 2}) : '',
			cheapest_short_parking_tariff_title: garageObject.cheapest_short_parking_tariff_title.length ? garageObject.cheapest_short_parking_tariff_title : undefined,
			contracted_project: convertZeroOneToBoolean(garageObject.contracted_project),
			contracted_due_date: garageObject.contracted_due_date,
		};

		garages.push(garage);
	}

	return garages;
}

export function convertFacets(data: any): Readonly<FacetGroup> {
	let facets: FacetGroup = {  };

	if( ! data.facets ) {
		console.info("Empty search_result");
		return facets;
	}

	for( let facet of data.facets ) {
		let facetStruct = facet[0]; //returned from drupal this way
		const facetName: string = Object.keys(facetStruct)[0];

		//empty facet, skip it
		if( facetName == '0' ) {
			console.warn('Empty facet ' , Object.keys(facetStruct['0'])[0]);
			continue;
		}

		for( let f of facetStruct[facetName] ) {
			let isFacetDisabled = false;
			let facetValue: string|undefined = undefined;
			//check if we are dealing with a boolean facet
			if( f.boolean ) { //yes, boolean facet
				
				if( f.value == false ) { //only show "true" selection to the frontend
					continue;
				}
				//check if there is only one value that has no results
				if( f.count == 0) {
					isFacetDisabled = true;
				}
			} else {
				facetValue = f.value
			}

			let groupName = '';
			if( f.group ) {
				groupName = f.group;
			}

			if( ! (groupName in facets) ) {
				facets[groupName] = {};
			}
			
			if( ! (facetName in facets[groupName]) ) {
				facets[groupName][facetName] = [];
			}

			const facet: Facet = {
				count: parseInt(f.count, 10),
				isActive: f.active,
				url: f.url,
				isDisabled: isFacetDisabled,
				value: facetValue
			}
		
			facets[groupName][facetName].push(facet);
		}
	}

	return facets;
}